let clientKey = process.env.REACT_APP_TOSS_CLIENT_KEY;
const { TossPayments } = window;

// 개발모드 일때는 테스트키를 사용한다.
if (process.env.NODE_ENV == "development") {
  clientKey = process.env.REACT_APP_TOSS_CLIENT_TEST_KEY;
}

export const tossPayments = TossPayments(clientKey);
